module.exports = __webpack_public_path__ + "img/Unidad6-4.397b4052.png";